import * as React from 'react'

import { Page } from '@webapp/core/components/Page'
import { useAppRoutes, useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { CardManagementPageTabStatuses } from './types'

const CardManagementViewChunk = React.lazy(() =>
  import('../feature-sets/CardManagementDetailsView').then(
    ({ CardManagementDetailsView }) => ({
      default: CardManagementDetailsView,
    })
  )
)

export const CardManagementDetailsPage = () => {
  const intl = useProcurifyIntl()
  const { url } = useAppRoutes()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.cardManagementDetailsPageTitle)}
      breadcrumbs={[
        {
          name: intl.formatMessage(messages.cardManagementPageTitle),
          link: url('CardManagementPage', {
            status: CardManagementPageTabStatuses.ACTIVE,
          }),
        },
        {
          name: intl.formatMessage(messages.cardManagementDetailsPageTitle),
        },
      ]}
    >
      <CardManagementViewChunk />
    </Page>
  )
}
